export const cabeceraModel = {
  ca: null,
  de: null,
  co: null,
  st: false,
};
